import { useEffect, useState } from "react";
import { useAppSelector } from "../../_app";
import { PayslipsService } from "../../_service";
import { Constant } from "../../config";
import { Notify, Utils } from "../../utils";
import {
  CPFReturnContainer,
  CPFReturnHeading,
  MonthContainer,
  MonthHeading,
  MonthHeadingContainer,
} from "../filing/CPFFilingStyles";
import { NavLink } from "react-router-dom";
import { LoaderContainer } from "../../CommonStyles";
import { Loader, PayslipModalPDF } from "../../components";
import EmployeePayslipModal from "./EmployeePayslipModal";
import { H3Heading } from "../appSettings/AppSettingsStyles";
import styled from "styled-components";
import moment from "moment";

const EmployeePayslips = () => {
  const [payslipData, setPayslipData] = useState<any>({});
  const [yearData, setYearData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedPayslipData, setSelectedPayslipData] = useState<any>([]);
  const [showPayslipModal, setShowPayslipModal] = useState(false);
  const user = useAppSelector((state) => state.user);

  const [selectedYear, setSelectedYear] = useState<string>(
    moment().format("YYYY")
  );

  const years = Array.from({ length: 10 }, (_, i) =>
    (new Date().getFullYear() - 5 + i).toString()
  );

  const getPayslipsForEmployee = async () => {
    setIsLoading(() => true);
    try {
      const { data, status } = await PayslipsService._getPayslipsForEmployee(
        user.defaultCompnayId,
        selectedYear
      );

      if (status === 200) {
        setPayslipData(() => data.data);
        const dates = Object.keys(data.data);
        const years = dates.map((dat) => dat.split("-")[0]);
        const yearSet = new Set(years);
        const yearArr = Array.from(yearSet);
        setYearData(() => yearArr);
      }
    } catch (err) {
      Notify(Constant.common.something_went_wrong, 0);
    }
    setIsLoading(() => false);
  };

  useEffect(() => {
    getPayslipsForEmployee();
  }, [selectedYear, user.defaultCompnayId]);

  console.log("yearData", yearData);

  return isLoading ? (
    <LoaderContainer>
      <Loader />
    </LoaderContainer>
  ) : (
    <div>
      <H3Heading>Employee Payslips</H3Heading>

      <FormGroup>
        <Label>Select Year:</Label>
        <Select
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option
              key={year}
              value={year}
              style={{
                backgroundColor: year == selectedYear ? "#e8f5e8" : "white",
                fontWeight: year == selectedYear ? "bold" : "normal",
              }}
            >
              {year}
            </option>
          ))}
        </Select>
      </FormGroup>
      {yearData.length > 0 ? (
        <MonthContainer>
          {yearData.map((year: any) => (
            <>
              <MonthHeadingContainer onClick={() => {}}>
                <MonthHeading>{year}</MonthHeading>
              </MonthHeadingContainer>
              <CPFReturnContainer
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                {Object.keys(payslipData).map(
                  (payslipDate) =>
                    payslipDate.split("-")[0] === year && (
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          setShowPayslipModal(() => true);
                          setSelectedPayslipData(
                            () => payslipData[payslipDate]
                          );
                        }}
                      >
                        {Utils._dateToShow(payslipDate)}
                      </a>
                    )
                )}
              </CPFReturnContainer>
              <EmployeePayslipModal
                documents={selectedPayslipData}
                isOpen={showPayslipModal}
                handleClose={() => setShowPayslipModal(() => false)}
              />
            </>
          ))}
        </MonthContainer>
      ) : (
        <NoRecordsMessage>
           No records found for {selectedYear}
        </NoRecordsMessage>
      )}
    </div>
  );
};

export default EmployeePayslips;

const FormGroup = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
`;

const Label = styled.label`
  min-width: 80px;
  color: grey;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 200px;
  &:focus {
    outline: none;
    border-color: #059bbf;
  }
`;

const NoRecordsMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-style: italic;
  margin: 20px 0;
  text-align: center;
  font-size: 1rem;
  margin-top: 2rem;
  height: 50vh;
`;
